const types = {
    SHOW_SHAKEN_STIR_DELETE_MODAL: 'SHOW_SHAKEN_STIR_DELETE_MODAL',
    SHOW_SHAKEN_STIR_ADVANCED_MODAL: 'SHOW_SHAKEN_STIR_ADVANCED_MODAL',

    SHOW_CNAM_CALLER_ID_MODAL: 'SHOW_CNAM_CALLER_ID_MODAL',
    SHOW_CNAM_DELETE_MODAL: 'SHOW_CNAM_DELETE_MODAL',
    SHOW_CNAM_EDIT_MODAL: 'SHOW_CNAM_EDIT_MODAL',

    SHOW_TRUSTED_CALLING_BUY_MODAL: 'SHOW_TRUSTED_CALLING_BUY_MODAL',

    SHOW_VOICE_INTEGRITY_MODAL: 'SHOW_VOICE_INTEGRITY_MODAL',
};

const state = () => ({
    _showShakenStirDeleteModal: false,
    _showShakenStirAdvancedModal: false,

    _showCNAMItem: null,
    _showCNAMCallerIDModal: false,
    _showCNAMDeleteModal: false,
    _showCNAMEditModal: false,

    _showTrustedCallingBuyModal: false,
    _typeTrustedCallingBuyModal: null,

    _showVoiceIntegrityModal: false,
});

const getters = {
    showShakenStirDeleteModal: (state) => state._showShakenStirDeleteModal,
    showShakenStirAdvancedModal: (state) => state._showShakenStirAdvancedModal,

    showCNAMItem: (state) => state._showCNAMItem,
    showCNAMCallerIDModal: (state) => state._showCNAMCallerIDModal,
    showCNAMDeleteModal: (state) => state._showCNAMDeleteModal,
    showCNAMEditModal: (state) => state._showCNAMEditModal,

    showTrustedCallingBuyModal: (state) => state._showTrustedCallingBuyModal,
    typeTrustedCallingBuyModal: (state) => state._typeTrustedCallingBuyModal,

    showVoiceIntegrityModal: (state) => state._showVoiceIntegrityModal,
};

const actions = {
    handleShowShakenStirDeleteModal({ commit }, status) {
        commit(types.SHOW_SHAKEN_STIR_DELETE_MODAL, status);
    },

    handleShowShakenStirAdvancedModal({ commit }, status) {
        commit(types.SHOW_SHAKEN_STIR_ADVANCED_MODAL, status);
    },

    handleShowCNAMCallerIDModal({ commit }, status) {
        commit(types.SHOW_CNAM_CALLER_ID_MODAL, status);
    },

    handleShowCNAMDeleteModal({ commit }, data) {
        commit(types.SHOW_CNAM_DELETE_MODAL, data);
    },

    handleShowCNAMEditModal({ commit }, data) {
        commit(types.SHOW_CNAM_EDIT_MODAL, data);
    },

    handleShowTrustedCallingBuy({ commit }, data) {
        commit(types.SHOW_TRUSTED_CALLING_BUY_MODAL, data);
    },

    async handleShowVoiceIntegrityModal({ commit, dispatch }, data) {
        commit(types.SHOW_VOICE_INTEGRITY_MODAL, data);
    },
};

const mutations = {
    [types.SHOW_VOICE_INTEGRITY_MODAL](state, status) {
        state._showVoiceIntegrityModal = status;
    },

    [types.SHOW_TRUSTED_CALLING_BUY_MODAL](state, { status, type }) {
        state._typeTrustedCallingBuyModal = type;
        state._showTrustedCallingBuyModal = status;
    },

    [types.SHOW_CNAM_EDIT_MODAL](state, { status, item }) {
        state._showCNAMItem = item;
        state._showCNAMEditModal = status;
    },

    [types.SHOW_CNAM_DELETE_MODAL](state, { status, item }) {
        state._showCNAMItem = item;
        state._showCNAMDeleteModal = status;
    },

    [types.SHOW_CNAM_CALLER_ID_MODAL](state, status) {
        state._showCNAMCallerIDModal = status;
    },

    [types.SHOW_SHAKEN_STIR_DELETE_MODAL](state, status) {
        state._showShakenStirDeleteModal = status;
    },

    [types.SHOW_SHAKEN_STIR_ADVANCED_MODAL](state, status) {
        state._showShakenStirAdvancedModal = status;
    },
};

export const CallingStore = {
    state,
    getters,
    actions,
    mutations,
};
